import { Badge } from '@/components/ui/badge';
import { Datum } from '@/domain/navigation/benachrichtigungen/components/details/shared/Datum';
import { DetailWrapper } from '@/domain/navigation/benachrichtigungen/components/details/shared/DetailWrapper';
import { Abwesenheitsantraege } from '@/domain/navigation/benachrichtigungen/types/AbwesenheitsAntraege';
import { mapMarkierung } from '@/domain/navigation/benachrichtigungen/utils/mapMarkierung';
import { mapAbwesenheitsGrundToIcon } from '@/domain/navigation/shared/utils/mapAbwesenheitsgrundToIcon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';

type StyleProps = CSSProperties & {
  '--badge-color': CSSProperties['color'];
};

export default function AbwesenheitsantragDetail({
  benachrichtigung,
}: {
  benachrichtigung: Abwesenheitsantraege;
}) {
  const { t } = useTranslation();

  return (
    <DetailWrapper
      mitarbeiter={benachrichtigung.mitarbeiter}
      content={
        <>
          <Badge
            className="rounded-full w-fit bg-[var(--badge-color)] hover:bg-[var(--badge-color)] text-xs"
            style={
              {
                '--badge-color':
                  mapMarkierung[benachrichtigung.markierung].base,
              } as StyleProps
            }>
            <FontAwesomeIcon
              className="text-xs max-h-3 max-w-3 overflow-hidden"
              icon={mapAbwesenheitsGrundToIcon(benachrichtigung.grund)}
            />
            {t(
              `entities.abwesenheiten.${benachrichtigung.grund.toUpperCase()}`,
            )}
          </Badge>
        </>
      }
      footer={<Datum von={benachrichtigung.von} bis={benachrichtigung.bis} />}
    />
  );
}
